import { useApolloClient } from '@apollo/client';
import { useCallback } from 'react';
import {
    type UploadGiftVoucherDocumentMutation,
    type UploadGiftVoucherDocumentMutationVariables,
    UploadGiftVoucherDocumentDocument,
} from '../../../../../api/mutations/uploadGiftVoucherDocument';
import { type ApplicationDocumentKind } from '../../../../../api/types';

const useUploadGiftVoucherDocument = (token: string, isTemporary: boolean = true) => {
    const apolloClient = useApolloClient();

    return useCallback(
        async (kind: ApplicationDocumentKind, file: File) => {
            if (!file || !kind) {
                return null;
            }

            if (file instanceof File) {
                const { data } = await apolloClient.mutate<
                    UploadGiftVoucherDocumentMutation,
                    UploadGiftVoucherDocumentMutationVariables
                >({
                    mutation: UploadGiftVoucherDocumentDocument,
                    variables: {
                        token,
                        kind,
                        upload: file,
                        isTemporary,
                    },
                });

                return data?.result?.uploadedFile;
            }

            return null;
        },

        [apolloClient, token, isTemporary]
    );
};

export default useUploadGiftVoucherDocument;
